const createFXAlertQuery = `mutation  createFxAlert( $req:CreateAlertInput, ) { 
    createFxAlert (input: $req) {
      ... on CreateAlertResponse {
        fxId
        response
        token
        }
      ... on ErrorResponse {
          correlationId
          errorCode
          issues {
              field
              issue
              code
              message         
          }
          legacyError
          message
          name
          priority
      }
      } }`
      